import InternImage from '../images/InternImage.jpg'


export const Bio = {
  name: "Vamsi Krishna",
  roles: [
    "Software Engineer",
    "Full-Stack Developer",
    "Backend Architect",
    "Competitive Programmer",
    "Problem Solver"
  ],
  description:
    "Computer Science graduate from IIIT Jabalpur with professional experience in distributed systems and full-stack development. Engineered high-performance applications with React, Next.js, Express, and MongoDB, achieving significant performance improvements. Solved 1000+ algorithmic problems with competitive ratings on LeetCode and Codeforces. Passionate about building scalable software solutions that solve real-world problems with technical excellence.",
  github: "https://github.com/VamsiKrishnaThota03",
  resume:
    "https://drive.google.com/file/d/1wp0rP9MVhlnnDkQUKnBh_jKH4W_wX3Je/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/thota-vamsi-krishna-a6b9b1264/",
  insta: "https://www.instagram.com/vamsi_royal03/",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "C++",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "SQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "TypeScript",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React.js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next.js",
        image: "https://cdn.worldvectorlogo.com/logos/nextjs-2.svg",
      },
      {
        name: "Redux",
        image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML5",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      },
      {
        name: "CSS3",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Vite",
        image: "https://vitejs.dev/logo.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express.js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg",
      },
      {
        name: "Django",
        image: "https://cdn.worldvectorlogo.com/logos/django.svg",
      },
      {
        name: "RESTful APIs",
        image: "https://cdn-icons-png.flaticon.com/512/5107/5107908.png",
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Distributed Systems DB",
        image: "https://cdn-icons-png.flaticon.com/512/5756/5756183.png",
      },
    ],
  },
  {
    title: "Tools & Methods",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "GitLab",
        image: "https://cdn.worldvectorlogo.com/logos/gitlab.svg",
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png",
      },
      {
        name: "Postman",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Agile Development",
        image: "https://cdn-icons-png.flaticon.com/512/6747/6747196.png",
      },
      {
        name: "TDD",
        image: "https://cdn-icons-png.flaticon.com/512/6295/6295417.png",
      },
    ],
  },
  {
    title: "Advanced Concepts",
    skills: [
      {
        name: "Operating Systems",
        image: "https://cdn-icons-png.flaticon.com/512/2172/2172894.png",
      },
      {
        name: "Computer Networks",
        image: "https://cdn-icons-png.flaticon.com/512/2593/2593633.png",
      },
      {
        name: "Distributed Systems",
        image: "https://cdn-icons-png.flaticon.com/512/6080/6080685.png",
      },
      {
        name: "Algorithm Design",
        image: "https://cdn-icons-png.flaticon.com/512/6295/6295417.png",
      },
      {
        name: "System Design",
        image: "https://cdn-icons-png.flaticon.com/512/1329/1329016.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "Software Development Engineer Intern",
    company: "Troywings Technologies",
    date: "Jun 2023 – Dec 2023",
    location: "Bangalore, India",
    desc: "Distributed System Optimization: Enhanced multi-tiered microservices using intelligent caching and concurrent job queues, improving throughput by 30% (Node.js, Redis, NGINX). Secure Authentication Mechanisms: Engineered multi-factor authentication with cryptographic protocols, ensuring secure session validation under load (JWT, bcrypt). User Management at Scale: Designed and scaled a user session service to handle 1000+ concurrent users with 20% latency reduction, mirroring distributed authentication scenarios. API Reliability and Fault Tolerance: Engineered resilient APIs with built-in retry, degradation logic, and observability hooks, maintaining 99.9% uptime for storage services.",
  },
  {
    id: 1,
    role: "Software Development Engineer Intern",
    company: "Komplai",
    date: "Jun 2025 – Jun 2025",
    location: "Bangalore, India",
    desc: "End-to-End Feature Development: Developed and deployed full-stack features using Next.js, Prisma, Docker, and SQL, enhancing user experience and backend efficiency across compliance workflows. Company CIN Lookup Integration: Integrated IDfy API for real-time Company CIN validation, automating KYB checks and reducing onboarding time by 30%. Product Analytics with Amplitude: Implemented Amplitude event tracking across core user flows, enabling data-driven insights into user behavior and improving feature adoption rates.",
  },
  {
    id: 2,
    role: "Freelance Frontend Developer",
    company: "Framewise.ai",
    date: "May 2025 – Jun 2025",
    location: "Remote",
    desc: "Developed the complete frontend for framewise.ai, a platform for AI-powered interviews. Implemented seamless integration with Python backend APIs (provided via Swagger) using Next.js, and built user interfaces for interview workflows, authentication, and results. Delivered a fully functional, responsive web application connecting users to AI interview services.",
  },
  {
    id: 3,
    role: "Software Development Engineer I – Alexa Craft Mobile Team",
    company: "Amazon",
    date: "Jul 2025 – Present",
    location: "Chennai, India",
    desc: "Monitoring & Reliability: Implemented CloudWatch monitors and alarms across Alexa’s Daily Essentials modules, improving service observability and reducing incident response time by 20%. Bug Fixes & Accessibility: Resolved production issues and accessibility bugs in Elements-Kitchen, Calendars, and Tasks pipelines, enhancing reliability for over 1M+ daily active Alexa users. Migration – DUB Exit Campaign: Enabled seamless Alexa Kitchen migration from DUB to ZAZ region by adding region flexibility and developing a new CDK package, ensuring zero downtime.",
  },
];

export const education = [
  {
    id: 0,
    school: "Indian Institute of Information Technology, Jabalpur",
    date: "Dec 2021 - May 2025",
    grade: "8.5 CGPA",
    desc: "Graduated with a Bachelor's degree in Computer Science and Engineering from IIIT Jabalpur, ranked among the top NITs in India. Completed coursework in Data Structures & Algorithms, Operating Systems, Distributed Systems, Computer Networks, Database Management, and System Design. Active member of the college's programming team and participated in multiple hackathons.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    school: "Narayana Junior College, Vijayawada",
    date: "June 2019 - March 2021",
    grade: "96.6%",
    desc: "Completed intermediate education with a focus on Mathematics, Physics, and Chemistry. Ranked in the top 5% of students statewide and qualified for JEE Advanced with a high percentile. Participated in various mathematics and science competitions, developing strong analytical and problem-solving skills.",
    degree: "Higher Secondary Education (10+2)"
  },
  {
    id: 2,
    school: "Ravindra Bharathi Group of Schools",
    date: "March 2019",
    grade: "10 CGPA",
    desc: "Completed secondary education with perfect 10 CGPA. Received multiple awards for academic excellence and participated in regional science exhibitions. Active in extracurricular activities including mathematics olympiads and coding competitions, which sparked my interest in computer science.",
    degree: "Secondary School Education (Class X)"
  },
];

// Default project images by category
export const defaultImages = {
  "web app": "https://img.freepik.com/free-vector/website-development-banner_33099-1687.jpg",
  "machine learning": "https://img.freepik.com/free-vector/artificial-intelligence-concept-landing-page_52683-24662.jpg",
  "mobile app": "https://img.freepik.com/free-vector/mobile-app-development-concept-illustration_114360-2120.jpg",
  "api": "https://img.freepik.com/free-vector/secure-data-sharing-concept-illustration_114360-7730.jpg",
  "backend": "https://img.freepik.com/free-vector/cloud-hosting-concept-illustration_114360-4957.jpg",
  "fullstack": "https://img.freepik.com/free-vector/programmer-working-web-development-code-engineer-programming-python-php-java-script-computer_90220-249.jpg",
  "default": "/images/default-project.jpg"
};

export const projects = [
  {
    id: 14,
    title: "IMF Gadget API",
    date: "Jan 2024 - Mar 2024",
    description:
      "A secure REST API for the Impossible Missions Force (IMF) to manage high-tech gadgets. Features include JWT authentication, dynamic mission success probability calculations, automatic codename generation, self-destruct mechanism, status tracking system, and filterable gadget search. Built with Node.js, Express, PostgreSQL, and Sequelize ORM, with comprehensive Swagger API documentation.",
    image:
      "/images/imf-gadget-api.png",
    tags: [
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "Sequelize ORM",
      "JWT Authentication",
      "Swagger",
      "RESTful API"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/imf-gadget-api",
    webapp: "https://imf-gadget-api-dhbc.onrender.com/api-docs",
  },
  {
    id: 11,
    title: "CryptoWeather Nexus",
    date: "Jan 2024 - Apr 2024",
    description:
      "A comprehensive dashboard integrating real-time cryptocurrency data and weather information. Features WebSocket connections with <50ms response time, integrating multiple APIs. Built with Next.js 14 and Tailwind CSS, improving code maintainability by 50%. Includes an interactive notification system processing 200+ events daily, with persistent favorites storage and fast load times.",
    image:
      "/images/crypto-weather-nexus.png",
    tags: [
      "Next.js",
      "Redux",
      "Tailwind CSS",
      "WebSocket",
      "TypeScript",
      "API Integration"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/crypto-weather-nexus",
    webapp: "https://crypto-weather-nexus-eta.vercel.app/",
  },
  {
    id: 12,
    title: "Smart Cab Allocation",
    date: "Oct 2023 - Dec 2023",
    description:
      "Designed and implemented a real-time ride tracking system, enabling 200+ users to monitor rides with precise updates. Created a route optimization algorithm, reducing travel time by 15% and supporting 100+ concurrent rides with fault-tolerant allocation.",
    image:
      "/images/smart-cab-allocation.png",
    tags: [
      "React",
      "Express",
      "MongoDB",
      "Google Maps API",
      "Real-time Tracking"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/smart-cab-allocation",
    webapp: "https://smart-cab-allocation-frontend.vercel.app/login",
  },
  {
    id: 10,
    title: "SQL Query Editor",
    date: "Mar 2024 - Apr 2024",
    description:
      "Built a high-performance SQL query editor with real-time syntax highlighting, achieving 400ms First Contentful Paint. Leveraged virtual scrolling for efficient rendering of 1000+ rows, implemented query history tracking with timestamps, and added CSV export functionality. Created a responsive interface with dark/light theme support.",
    image:
      "/images/sql-query-editor-screenshot.png",
    tags: [
      "React",
      "Vite",
      "CodeMirror",
      "React-Window",
      "CSS",
      "Virtual Scrolling"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/sql-query-editor",
    webapp: "https://sql-query-editor-fawn.vercel.app/",
  },
  {
    id: 15,
    title: "AI-Powered Task Management System",
    date: "Feb 2024 - Apr 2024",
    description:
      "A modern task management application with real-time features and AI integration. Built with Golang backend (Gin framework) and Next.js frontend, the system enables seamless task creation, assignment, and tracking with WebSocket-powered updates. Key features include JWT authentication, AI-powered task suggestions using Gemini API, and a responsive Tailwind CSS interface. The application demonstrates full-stack development with a focus on real-time functionality and AI assistance.",
    image:
      "/images/task-management.png",
    tags: [
      "Golang",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "PostgreSQL",
      "WebSockets",
      "Gemini API",
      "JWT Authentication"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/task-management",
    webapp: "",
  },
  {
    id: 16,
    title: "Ride-Sharing Platform",
    date: "Feb 2024 - Apr 2024",
    description:
      "A comprehensive ride-sharing platform with three distinct user roles: Traveler, Traveler Companion, and Admin. Features include real-time ride sharing via WhatsApp/SMS with automatic link expiration, real-time location tracking with Leaflet.js, geofence notifications, and comprehensive audit trails. Built with React.js frontend and Node.js/Express backend, using PostgreSQL for data storage and WebSockets for real-time updates and tracking.",
    image:
      "/images/ride-sharing-platform.png",
    tags: [
      "React.js",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "WebSockets",
      "Leaflet.js",
      "JWT Authentication",
      "Bootstrap"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/Ride-Sharing-Platform",
    webapp: "https://ride-sharing-platform-frontend.vercel.app/",
  },
  {
    id: 17,
    title: "Multilingual FAQ System",
    date: "Mar 2024 - Apr 2024",
    description:
      "A Django-based FAQ management system with multilingual support using the deep-translator API for automatic translations. Features include a WYSIWYG editor through django-ckeditor, Redis caching for optimized performance, and RESTful API endpoints that provide localized FAQ content in multiple languages including English, Hindi, and Bengali with simple language parameter switching.",
    image:
      "/images/faq-project.png",
    tags: [
      "Django",
      "Django REST Framework",
      "Redis",
      "Python",
      "Deep Translator API",
      "Multilingual Support",
      "CKEditor",
      "API Development"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/faq_project",
    webapp: "",
  },
  {
    id: 13,
    title: "INotebook",
    date: "Aug 2023 - Oct 2023",
    description:
      "A secure cloud-based notes management application built with the MERN stack. Features user authentication, real-time CRUD operations for notes, and tags organization. Implemented JWT-based security to protect user data and ensure private note access. Responsive design works seamlessly across desktop and mobile devices.",
    image:
      "/images/inotebook-screenshot.png",
    tags: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "JWT Authentication",
      "CRUD Operations"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/INotebook",
    webapp: "",
  },
  {
    id: 18,
    title: "Blog Application",
    date: "Mar 2024",
    description:
      "A full-stack blog application built with React, TypeScript, and Node.js. Features user authentication, CRUD operations for blog posts, responsive design with Tailwind CSS, and dark mode support. Deployed on Vercel (frontend) and Render (backend) with a PostgreSQL database on Neon.",
    image: "https://img.freepik.com/free-vector/blogging-concept-illustration_114360-1038.jpg",
    tags: [
      "React",
      "TypeScript",
      "Node.js",
      "PostgreSQL",
      "Tailwind CSS",
      "Express.js"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/blog-app",
    webapp: "https://blog-app-seven-ruddy.vercel.app/",
  },
  {
    id: 9,
    title: "Fusion - Institute ERP",
    date: "Jan 2024 - present",
    description:
      "Worked on my college website as a developer and UI/UX designer. FusionIIIT is the automation of various functionalities,modules, and tasks of/for PDPM IIITDM Jabalpur beingdeveloped in python3.8 and using Django.",
    image: "https://img.freepik.com/free-vector/cloud-services-isometric-composition-with-big-cloud-computing-infrastructure-elements-connected-with-dashed-lines-vector-illustration_1284-30495.jpg",
    tags: [
      "Django",
      "Postgress SQL",
      "Java Script",
      "Bootstrap",
      "HTML",
      "CSS",
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/Fusion",
  },
  {
    id: 0,
    title: "Bite Cloud",
    date: "Apr 2023 - May 2023",
    description:
      "Developed a MERN (MongoDB, Express.js, React.js, Node.js) stack-based project designed to deliver comprehensive information on restaurants.",
    image:
      "https://github.com/VamsiKrishnaThota03/food-delivery/blob/master/frontend/public/food1.jpg?raw=true",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/food-delivery",
  },
  {
    id: 1,
    title: "Trade",
    date: "Dec 2022 - Feb 2023",
    description:
      "A PHP and sql based project which helps customers to trade any type of materials and the customers can also add their own items in our website.",
    image:
      "https://github.com/VamsiKrishnaThota03/food-delivery/blob/master/frontend/public/trade1.jpg?raw=true",
    tags: [
      "PHP",
      "MongoDb",
      "Java Script",
      "HTML",
      "Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/Trade",
  },
  {
    id: 2,
    title: "Plagarism Detector",
    date: "Aug 2023 - Nov 2023",
    description:
      "A Machine Learning Project for checking the similarity between two documents using the concept of Cosine Similarity.",
    image:
    "https://github.com/VamsiKrishnaThota03/food-delivery/blob/master/frontend/public/plagarism.png?raw=true",
    tags: ["Python", "Keras", "TensorFlow"],
    category: "machine learning",
    github: "https://github.com/VamsiKrishnaThota03/Plagarism-Checker",
  },
  {
    id: 19,
    title: "Movie Search App",
    date: "Jul 2025",
    description: "A beautiful and modern movie search application built with Next.js, TypeScript, and OMDB API. This app allows users to search for movies, view details, and rate their favorite films.",
    image: "https://img.freepik.com/free-vector/movie-night-concept-illustration_114360-1197.jpg",
    tags: [
      "Next.js",
      "TypeScript",
      "Redux Toolkit",
      "Tailwind CSS",
      "shadcn/ui",
      "React Query",
      "OMDB API"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/movie-imdb",
    webapp: "https://movie-imdb-omega.vercel.app/movies",
  },
  {
    id: 20,
    title: "Job Management Admin Interface",
    date: "Jul 2025",
    description: "A full-stack application for managing job postings, built with Next.js, Mantine, and NestJS. Features job listing with advanced filters, create/edit/delete job postings, responsive design with Mantine UI, form validation with React Hook Form, and PostgreSQL database with TypeORM.",
    image: "https://img.freepik.com/free-vector/job-interview-illustration_23-2148813982.jpg",
    tags: [
      "Next.js",
      "TypeScript",
      "Mantine UI",
      "React Hook Form",
      "NestJS",
      "TypeORM",
      "PostgreSQL",
      "Class Validator"
    ],
    category: "web app",
    github: "https://github.com/VamsiKrishnaThota03/job-management",
    webapp: "https://job-management-orpin.vercel.app/",
  },
  ];
